var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCategoryQuestion = function SvgCategoryQuestion(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 41.64C38 35.44 42.36 31 50.22 31 57.2 31 62 34.99 62 41.2c0 3.98-2.18 6.64-5.67 8.86-3.5 2.21-4.37 3.54-4.37 5.76v1.33h-6.1v-1.78c-.44-3.98 1.3-6.2 4.8-8.42 3.05-1.77 4.36-3.54 4.36-5.76 0-2.66-2.18-4.87-5.24-4.87-3.49 0-5.67 2.21-5.67 5.32zM49.35 70c-2.62 0-4.37-1.77-4.37-3.99 0-2.66 1.75-3.99 4.37-3.99 2.61 0 4.36 1.78 4.36 4 0 2.2-1.75 3.98-4.36 3.98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 88c-21.01 0-38-16.99-38-38s16.99-38 38-38 38 16.99 38 38-16.99 38-38 38m0-69.3A31.1 31.1 0 0 0 18.7 50 31.1 31.1 0 0 0 50 81.3 31.1 31.1 0 0 0 81.3 50 31.1 31.1 0 0 0 50 18.7"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCategoryQuestion);
export default ForwardRef;